import { useMemo, useState } from 'react'
import { faBooks } from '@fortawesome/pro-solid-svg-icons'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'

import { RankmiTable } from '@rankmi/rankmi-table'
import {
  generateTableLocale,
  joinKeys,
  useTranslationRankmi,
} from 'helpers/translations.helper'
import { IEvaluationResume } from 'models/evaluation.model'
import { useColumns } from './hooks/useColumns'
import { prefixTable } from './hooks/useColumns/constants'

interface EvaluationsProps {
  evaluations: IEvaluationResume[]
  onRefresh: () => void
}

export const Evaluations = ({ evaluations, onRefresh }: EvaluationsProps) => {
  const [text, setText] = useState('')

  const total = evaluations.length

  const columns = useColumns({ onRefresh })

  const dataSource = useMemo(
    () =>
      evaluations
        .filter((evaluation) => {
          if (!text) return true
          return evaluation.name.toLowerCase().includes(text.toLowerCase())
        })
        .map((evaluation) => ({
          ...evaluation,
          key: evaluation.id,
        })) || [],
    [evaluations, text]
  )

  const tRelative = useTranslationRankmi({
    prefix: joinKeys(prefixTable),
  })

  const locale = useMemo(
    () =>
      generateTableLocale({
        header: {
          rowsCount: tRelative('rowsCount'),
          rowsCount_plural: tRelative('rowsCount_plural'),
        },
      }),
    [tRelative]
  )

  return (
    <Row className={classNames('mt-4')}>
      <Col xs={12}>
        <RankmiTable
          columnHeaders={columns}
          data={dataSource}
          total={total}
          changeColumnsVisibility
          onSearch={(text: string) => setText(text)}
          search={text}
          countIcon={faBooks}
          responsive
          locale={locale}
        />
      </Col>
    </Row>
  )
}
